exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-controls[data-v-746a4074]{width:100%\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-746a4074","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/shared-components/forms/SerieForm.vue
// module id = 178
// module chunks = 0